var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53 3.03c-.511.512-.78 1.465-.78 3.47v10c0 2.005.269 2.958.78 3.47.512.511 1.465.78 3.47.78h6c2.005 0 2.958-.269 3.47-.78.511-.512.78-1.465.78-3.47v-10c0-2.005-.269-2.958-.78-3.47-.512-.511-1.465-.78-3.47-.78H6c-2.005 0-2.958.269-3.47.78ZM1.47 1.97C2.458.98 4.005.75 6 .75h6c1.995 0 3.542.231 4.53 1.22.989.988 1.22 2.535 1.22 4.53v10c0 1.995-.231 3.542-1.22 4.53-.988.989-2.535 1.22-4.53 1.22H6c-1.995 0-3.542-.231-4.53-1.22C.48 20.042.25 18.495.25 16.5v-10c0-1.995.231-3.542 1.22-4.53Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 5A.75.75 0 0 1 7 4.25h4a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 5ZM9 16.25a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Zm-2.3.8a2.3 2.3 0 1 1 4.6 0 2.3 2.3 0 0 1-4.6 0Z",
    fill: "currentColor"
  })));
};
export default SvgPhone;